import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import Button from "../Button";
import * as s from "./Navigation.module.scss";

type NavigationProps = PropsWithChildren<{
	isOpen: boolean;
	onClose: () => void;
	closeButtonLabel: string;
	isSubNav?: boolean;
}>;

const Navigation: FC<NavigationProps> = ({
	isOpen,
	onClose,
	closeButtonLabel,
	isSubNav,
	children,
}) => {
	return (
		<nav
			className={cn(s.navigation, {
				[s.isOpen]: isOpen,
				[s.subNav]: isSubNav,
			})}
		>
			<Button
				variant="noBg"
				label={closeButtonLabel}
				iconLeft
				icon={isSubNav ? "arrow-left" : "close"}
				className={s.closeButton}
				onClick={onClose}
				noPaddingInline
			/>
			{children}
		</nav>
	);
};
export default Navigation;
